
webpack.register(
    'modules/live-tv-schedule/live-tv-schedule',
    function() {
        return import('modules/live-tv-schedule/live-tv-schedule');
    },
    true
);